import PropTypes from 'prop-types';
import React from 'react';
import { Card, Grid } from 'semantic-ui-react';
import styles from '../../Proposal.scss';
import currencyFormatter from 'currency-formatter';

export default class ServiceShow extends React.Component {
  static propTypes = {
    service: PropTypes.object.isRequired,
    readOnly: PropTypes.bool
  };

  render() {
    const service = this.props.service;
    const quantity = service.quantity || 1;
    const price = (service.price_cents || 0) / 100;
    const cardStyles = { background: 'transparent' };
    if (!this.props.readOnly) cardStyles.userSelect = 'none';

    return (
      <Card
        link={!this.props.readOnly}
        fluid
        style={cardStyles}
        className={styles.noShadow}
      >
        <Card.Content style={{ paddingLeft: 0, marginLeft: '1em' }}>
          <Grid>
            <Grid.Row>
              <Grid.Column width={16}>
                <strong>{service.title}</strong>
                <br />
                <span
                  className={styles.description}
                  dangerouslySetInnerHTML={{ __html: service.description }}
                />
                <div className={styles.itemTotalMobile}>
                  <div style={{ float: 'left' }} className={styles.qtyPrice}>
                    ({quantity} @ &nbsp;
                    {currencyFormatter.format(price, { code: service.price_currency })})
                  </div>
                  <div style={{ float: 'right' }}>
                    {currencyFormatter.format(quantity * price, {
                      code: service.price_currency
                    })}{' '}
                  </div>
                </div>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card.Content>
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/Library/LibraryItemShow.js